import FullViewLoading from 'components/common/FullViewLoading';
import IsAxiosError from 'components/common/IsAxiosError';
import type { ComponentProps } from 'react';
import { useEffect, useState } from 'react';
import { useGetApplicationSummaryQuery } from 'rtk/query/apis/applications';
import type { TInterviewSummary } from 'types/interviewSummary.types';
import Summary from './Summary';

interface Props extends ComponentProps<'div'> {
  applicationId: string;
  summary?: TInterviewSummary;
}

const ApplicationSummary = ({ applicationId, summary, ...props }: Props) => {
  const { data, isLoading, isFetching, isError, error } = useGetApplicationSummaryQuery(
    { applicationId },
    {
      skip: summary ? true : false,
    },
  );
  const [activeSummaryId, setActiveSummaryId] = useState<string>();

  useEffect(() => {
    if (data?.summary) {
      setActiveSummaryId(data.summary._id);
    }
  }, [data]);

  useEffect(() => {
    if (summary) {
      setActiveSummaryId(summary._id);
    }
  }, [summary]);

  if (isLoading || isFetching) {
    return <FullViewLoading title="Loading application summary..." />;
  }

  if (isError) {
    return <IsAxiosError error={error} />;
  }

  console.log('ApplicationSummary data', data);

  if (summary) {
    return <Summary summary={summary} isActive={activeSummaryId === summary._id} />;
  }

  if (!data) {
    return <FullViewLoading title="Loading application summary..." />;
  }

  if (!data.summary) {
    return (
      <div {...props} className="hubert-vertical-center flex px-11 text-center">
        <span>TODO: This applicant has no summaries yet.</span>
      </div>
    );
  }

  return <Summary key={data.summary._id} summary={data.summary} isActive={activeSummaryId === data.summary._id} />;
};

export default ApplicationSummary;
